import { render, staticRenderFns } from "./DocumentsDeleteTableComponent.vue?vue&type=template&id=1429b4bf&scoped=true&"
import script from "./DocumentsDeleteTableComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentsDeleteTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsDeleteTableComponent.vue?vue&type=style&index=0&id=1429b4bf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1429b4bf",
  null
  
)

export default component.exports